import React, { Component } from 'react';
import moment from 'moment';
import 'moment/locale/es'
import logo from '../../assets/svg/logo-header-sp.svg';
import iconoUsuarioBlanco from '../../assets/svg/icono-usuario-blanco.svg';
import './NavTef.css';

class NavTef extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {
    const { user, date } = this.props;
    const urlTef = process.env.URL_PORTAL_PRIVADO
    return (

      <div className="navbar navbar-default top-navbar ng-scope" role="navigation" ng-controller="HeaderController">
        <div className="container-fluid nopadding-right-xs">
          <div className="row">
            <div className="col-sm-10 offset-sm-1">
              <div className="row">
                <div className="col-3">
                  <div className="top-menu-header">
                    <a href={urlTef} target="_self">
                      <img src={logo} alt="www.coopeuch.cl" />
                    </a>
                  </div>
                </div>
                <div className="col-6">
                  <div className="header-user-info">
                    <div className="ng-binding">{ date && moment(date).format('dddd DD MMM YYYY, h:mm')}</div>
                  </div>
                </div>
                <div className="col-3">
                  <div className="header-user-data">
                    <div className="person-info ng-binding">
                      {user && (
                        <>
                          <img src={iconoUsuarioBlanco} alt="Ilana  Treib  Bondurant" />
                          <span>{user.toLowerCase() }</span>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
};

export default NavTef;